<script>
  export default {
    components: {
      PrivacyContent: () => import("@components/Privacy/PrivacyContent"),
    },
  }
</script>
<template>
  <section :class="$style.sectionContent" class="section">
    <div class="container">
      <PrivacyContent/>
    </div>
  </section>
</template>
<style lang="scss" module>
  .sectionContent {
    padding-top: 0;
    @include max-lg {
      padding-top: 110px;
    }
    :global {
      .sectionContent {
        
      }
    }
  }
</style>
